import { createContext, useContext, useState } from "react";

const BannerContext = createContext({
  visible: false,
  setVisible: (value: boolean) => {},
  hasNewVersion: false,
  setHasNewVersion: (visible: boolean) => {},
  setHasUnClassifiedDoc: (visible: boolean) => {},
  hasUnClassifiedDoc: false,
});

export const BannerProvider = ({ children }: { children: React.ReactNode }) => {
  const [visible, setVisible] = useState(false);
  const [hasNewVersion, setHasNewVersion] = useState<boolean>(false);
  const [hasUnClassifiedDoc, setHasUnClassifiedDoc] = useState<boolean>(false);

  return (
    <BannerContext.Provider
      value={{
        visible,
        setVisible,
        hasNewVersion,
        setHasNewVersion,
        hasUnClassifiedDoc,
        setHasUnClassifiedDoc,
      }}
    >
      {children}
    </BannerContext.Provider>
  );
};

export const useBanner = () => useContext(BannerContext);
